<template>
    <div class="input-group mb-3">
        <input 
            type="search" 
            id="search-field" 
            class="form-control"
            :placeholder="translations.search" 
            v-model="searchValue"
            v-on:keyup.enter="search(searchValue)"
        />

        <div class="input-group-append">
            <button class="btn btn-primary" type="button" v-on:click="search(searchValue)">
                <i class="fas fa-search"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['translations'],

    data() {
        return {
            searchValue: ''
        };
    },

    methods: {
        search(searchValue) {
            this.$emit('onFilter', { data: { searchValue } });
        }
    }
};
</script>
